import React, { createContext, useContext, useState, useEffect } from 'react';
import { siteAPI } from '../lib/api';

const SiteSettingsContext = createContext(null);

const DEFAULT_SETTINGS = {
  site_name: 'Fikkr',
  logo_url: '',
};

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await siteAPI.getSettings();
        setSettings(prev => ({ ...prev, ...res.data }));
      } catch (err) {
        // Use defaults silently
      }
    };
    fetchSettings();
  }, []);

  return (
    <SiteSettingsContext.Provider value={settings}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  const context = useContext(SiteSettingsContext);
  if (!context) {
    throw new Error('useSiteSettings must be used within a SiteSettingsProvider');
  }
  return context;
}
